import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { propArrayShape, propArrayStr, propBool, propFunc, propNumber, propStr, } from '../../../../../helpers/custom-prop-types';
import SlideSearchPlan from '../../../../Ui/SlideSearch/Plan';
import ProffitSearchLandingPageCtaButton from '../../Parts/ProffitSearchLandingPageCtaButton';
const ProffitSearchLandingPagePlansBody = (props) => {
    const { currentTab, functions, isEndTrial, plan, plans, showFormModal } = props;
    return (_jsx("div", Object.assign({ className: 'proffit_search_landing_page_plans_body' }, { children: plans.map((v, i) => (_jsx(SlideSearchPlan, { buttonComponent: v.isDisabled ? (_jsx("span", Object.assign({ className: 'plan_link button disabled' }, { children: v.buttonText }))) : (_jsx(ProffitSearchLandingPageCtaButton, { className: 'plan_link', isEndTrial: isEndTrial, plan: plan, showFormModal: showFormModal, text: v.buttonText })), className: clsx('plan_item', i === currentTab && 'active'), functions: functions, plan: v }, v.title))) })));
};
ProffitSearchLandingPagePlansBody.propTypes = {
    currentTab: propNumber().isRequired,
    functions: propArrayStr().isRequired,
    isEndTrial: propBool().isRequired,
    plan: propStr(),
    plans: propArrayShape().isRequired,
    showFormModal: propFunc().isRequired,
};
ProffitSearchLandingPagePlansBody.defaultProps = {
    plan: undefined,
};
export default ProffitSearchLandingPagePlansBody;
